<template>
  <div class="menu menu-bar-drawer desktop-nav">
    <div class="menu-bar menu-bar-container">
      <div class="control-nav-items items">
        <div
          v-for="item in items"
          :key="'item-' + item.id"
          class="menu-item"
          @mouseover="onMouseOver(item.name)"
          :class="[hover === item.name && 'hover', item.name]"
          @mouseleave="onMouseLeave"
        >
          <a
            class="menu-link control"
            :class="{ 'menu-link-active': routeItem && '' + item.id === '' + (routeItem.parentId || routeItem.id) }"
            :href="item.url == '' ? null : item.url"
          >
            <span class="menu-item-name control"> {{ item.name }} </span>
          </a>
          <div class="menu-dropdown">
            <ul v-if="item && item.items && item.items.length > 0">
              <li v-for="subItem in item.items" :key="'item-item-' + subItem.id" class="menu-dropdown-item text-nav">
                <a :class="subItem.name" @click="loadSectionUrl(subItem.url)" :href="subItem.url == '' ? null : subItem.url">{{ subItem.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageMenu',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    routeItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      secondaryMenuItemToShow: '',
      topLevelMenuItem: '',
      hover: null,
    };
  },

  methods: {
    loadSectionUrl(url) {
      window.location = url;
    },

    isTopLevelMenuItemInactive(menuItem) {
      return (
        menuItem &&
        this.topLevelMenuItem === menuItem.name &&
        this.routeItem &&
        menuItem.id.toLowerCase() !== this.routeItem.parentMenuItem.toLowerCase()
      );
    },
    isSecondaryLeveLMenuItemActive(menuItem) {
      return (
        menuItem &&
        this.routeItem &&
        (this.routeItem.parentMenuItem === 'product' || this.routeItem.name === menuItem.name) &&
        (this.routeItem.id === menuItem.id || this.routeItem.parentId === menuItem.id)
      );
    },
    hasSecondaryLeveLMenuItems(menuItem) {
      return (
        menuItem &&
        menuItem.items &&
        menuItem.items[0] &&
        menuItem.items[0].path?.includes(this.secondaryMenuItemToShow) &&
        this.secondaryMenuItemToShow !== ''
      );
    },
    showArrow(subItem, item) {
      return subItem && item && subItem.name.toUpperCase() !== 'NEW' && item.id.toLowerCase() === 'product';
    },
    onMouseOver(item) {
      this.hover = item;
    },
    onMouseLeave() {
      this.hover = null;
    },
  },
};
</script>
<style lang="postcss">
@import '@/pixel/style/variables';

.menu {
  background-color: var(--white);
  width: 100%;

  .menu-link-inactive {
    color: var(--grey-dark);
  }

  .items {
    display: flex;
    &.control-nav-items {
      > div {
        position: relative;
      }
    }
  }

  .force-control-nav {
    position: relative;
  }

  .menu-link {
    display: block;
    color: var(--grey-medium);
    font-size: var(--font-size-14);
    line-height: var(--line-height-14);
    &.control {
      position: relative;
    }

    /* purgecss ignore */
    &:hover {
      color: var(--grey-dark);
    }

    &.menu-link-active {
      color: var(--accent-color);
    }
  }

  .menu-dropdown {
    z-index: 12;
    box-shadow: 0 var(--box-shadow-blur) var(--box-shadow-spread) var(--shadow-color);
    display: flex;
    border-radius: var(--space-1);
    opacity: 0;
    position: absolute;
    list-style-type: none;
    margin: 0;
    margin-top: 15px;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    visibility: hidden;
    background-color: var(--white);
    font-family: var(--font-regular);
    left: -16px;

    .main {
      padding: 24px;
      max-width: 320px;
      a {
        padding: 16px;
      }
      img {
        display: block;
        margin: 0 auto;
      }
    }

    ul {
      width: 100%;
      text-align: left;
      box-sizing: content-box;
      min-width: 200px;
      opacity: 0;
    }
  }

  .menu-dropdown-item {
    font-size: var(--font-size-14);
    width: 100%;
    line-height: 1.25rem;
    white-space: normal;

    > a {
      padding: 12px 16px;
    }

    .section-image {
      transition-duration: 0.3s;
    }

    &.main {
      img {
        padding-bottom: var(--space-4);
      }

      a {
        text-align: left;
      }
    }

    /* purgecss ignore */
    &:not(:last-child) {
      border-bottom: solid 1px var(--white);
    }

    /* purgecss ignore */
    &:first-child {
      border-radius: 4px 4px 0px 0px;
    }

    /* purgecss ignore */
    &:last-child {
      border-radius: 0px 0px 4px 4px;
    }

    .section-image {
      width: 100%;
      max-width: 125px;
      height: auto;
      margin: 0 auto;
      padding-bottom: var(--space-4);
      img {
        display: block;
        width: 100%;
        min-height: 100%;
      }
    }

    .menu-link {
      display: block;
      color: var(--font-color);
      font-size: var(--font-size-14);
      line-height: var(--line-height-14);
    }

    a {
      line-height: 1;
      text-decoration: none;
      display: block;
      transition-duration: 0.2s;

      span {
        height: var(--space-10);
        width: var(--space-10);
        border-radius: 20px;
        float: right;
        text-align: center;
      }

      &.menu-link-active {
        color: var(--accent-color) !important;
      }
    }

    a:hover {
      color: var(--accent-color);
      transition-duration: 0.2s;
    }
  }

  .menu-dropdown-item:hover {
    cursor: pointer;

    a.control {
      color: var(--accent-color);
    }
  }

  .menu-item {
    background-color: var(--white);
    margin-top: 15px;
    padding-bottom: 15px;
    margin-right: var(--space-4);
    white-space: nowrap;

    a.control {
      /* purgecss ignore */
      &:hover {
        color: var(--accent-color);
      }
      span.control {
        /* purgecss ignore */
        &:hover {
          color: var(--accent-color);
        }
      }
    }

    /* purgecss ignore */
    &:hover,
    &.hover,
    .menu-link-active {
      > a {
        color: var(--accent-color);
      }

      .menu-dropdown {
        opacity: 1;

        visibility: visible;

        .main,
        ul {
          opacity: 1;
        }

        li.control {
          a:hover {
            color: var(--accent-color) !important;
          }
        }
      }
    }
  }
}
</style>
